export enum TypeMenssage {
    success = 0,
    danger = 1,
    warning  = 2,
    info = 3
}